import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { HomeModule } from './home/home.module';
import { AuthGuard } from './services/auth.guard';
import { AuthService } from './services/auth.service';
import { SecureInnerPagesGuard } from './services/secure-inner-pages.guard';
import { StorageService } from './services/local-storage.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './services/http-error-interceptor.service';
import { BaseURLInterceptor } from './services/base-urlinterceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ModalComponent } from './modal/modal.component';
import { ShipmentService } from './services/shipment.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GuaranteeService } from './services/guarantee.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AdminModule } from './admin/admin.module';
import { UserManagementService } from './services/user-management.service';
import { SettingService } from './services/setting.service';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
   
 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HomeModule,
    AdminModule,
    BrowserAnimationsModule ,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ],
  providers: [AuthService, AuthGuard, SecureInnerPagesGuard, StorageService, ShipmentService,  GuaranteeService,UserManagementService,  Title,
    { provide: HTTP_INTERCEPTORS, useClass: BaseURLInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (setting: SettingService) => function() {return setting.loadSettings()},
      deps: [SettingService],
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}